export default __webpack_public_path__ + "static/media/006-pompom-blue.f666192e.svg";